import axios from 'axios'
import jwtToken from './getJwtToken'

const API_URL = process.env.VUE_APP_API_URL

export function isApiErrorResponse(error: unknown) {
  const { success, status_code, errors } = error as ApiResponseError

  return !success && status_code >= 400 && errors
}

export function formatWorksApiErrors(respError: ApiResponseError): ApiErrors {
  if (!respError.errors) {
    return {}
  }

  if (!Object.keys(respError.errors).length) {
    return {
      0: [respError.message],
    }
  }

  return Object.entries(respError.errors).reduce<ApiErrors>(
    (acc, [key, value]) => ({ ...acc, [key.replace('musicWork.', '')]: value }),
    {},
  )
}

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    Accept: 'application/json',
    Authorization: `Bearer ${jwtToken}`,
    'Accept-Language': document?.querySelector('html')?.getAttribute('lang') || 'en',
  },
})

api.interceptors.response.use(({ data }) => {
  if (!data.success) {
    return Promise.reject<ApiResponseError>(data)
  }

  return data
})

export default api
